export default {
  rememberMe: 'मुझे याद रखें',
  forgotYourPassword: 'अपना पासवर्ड भूल गए?',
  signIn: 'साइन इन करें',
  newHere: '¿यहां नया?',
  openAccount: 'खाता खोलें',
  haveAccount: '¿पहले से ही एक खाता है?',
  fullName: 'पूरा नाम',
  country: 'देश',
  phone: 'फोन',
  email: 'ईमेल',
  iAgree: 'मैं सहमत हूं',
  termsAndConditions: 'नियम और शर्तों का समझौता',
  signUp: 'नाम लिखो',
  recoverPassword: 'अपना पासवर्ड रिकवर करें',
  recover: 'पुनर्प्राप्त',
  goBack: 'पस जाओ',
  weHaveSentYouACode: 'हमने आपको एक कोड भेजा है',
  receivedCode: 'कोड प्राप्त',
  newPassword: 'नया पासवर्ड',
  confirmNewPassword: 'अपने नए पासवर्ड की पुष्टि करें',
  passwordSuccessfullyChanged: 'पासवर्ड सफलतापूर्वक बदल गया'
}
